import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";
import { DATATEST } from "constants/integration";

/** @augments {PureComponent<any, any>} */
class Refine extends PureComponent {
    render() {
        return (
            <SvgIcon data-test={DATATEST.GALLERY.FILTER_BTN} {...this.props}>
                <path
                    d="M2.8,0h18.4c0.7,0,1,0.8,0.6,1.3L14.2,10c-0.1,0.1-0.2,0.3-0.2,0.5V21
                    c0,0.3-0.1,0.6-0.4,0.7l-2.4,2.2c-0.5,0.3-1.2-0.1-1.2-0.7l0-12.6c0-0.2-0.1-0.4-0.2-0.5L2.2,1.4C1.7,0.8,2.1,0,2.8,0z"
                />
            </SvgIcon>
        );
    }
}

export default Refine;
